export default __webpack_public_path__ + "static/media/enter_docs.08548b01.jpg";